<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadRingGroups(1, null, true)">

      <template slot="actions">
        <vs-input type="number" :placeholder="$t('ring_group.filter.ring_group')" v-model="ringGroupFormData.group" class="configuration-inbound-ring-group-input" />
        <vx-input-group>
          <vs-input :placeholder="$t('ring_group.filter.ring_name')" v-model="ringGroupFormData.name" class="configuration-inbound-ring-name-input" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationRingGroupsButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addRingGroup">{{ $t('ring_group.button.add_ring_group') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input type="number" :placeholder="$t('ring_group.filter.ring_group')" v-model="ringGroupSearchParams.ringGroup" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('ring_group.filter.ring_name')" v-model="ringGroupSearchParams.ringName" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadRingGroups(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="ringGroupDataContainer" :title="$t('ring_group')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-inbound-ring-group-list
        :ringGroups="ringGroups"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-inbound-ring-group-list>

      <template slot="footer">
        <paginate
          :total="ringGroupPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadRingGroups"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import RingGroup from '@/models/RingGroup'
import SharedUserConfigurationInboundRingGroupList from '@/views/Shared/Configuration/Inbound/RingGroups/List'
import Paginate from '@/mixins/paginate'

export default {
  name: 'User.Configuration.Inbound.RingGroup',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationInboundRingGroupList
  },
  data () {
    return {
      ringGroupsEdit: {},
      ringGroups: {},
      ringGroupPages: 1,
      ringGroupFormData: {
        company_id: '',
        name: '',
        group: '',
        id: ''
      },
      ringGroupFormErrors: {},
      itemPerPage: null,
      ringGroupSearchParams: {
        ringGroup: typeof this.$route.query.ringGroup !== 'undefined' ? this.$route.query.ringGroup : '',
        ringName: typeof this.$route.query.ringName !== 'undefined' ? this.$route.query.ringName : ''
      }

    }
  },
  mounted () {
    this.loadRingGroups(this.initialPage,  null, false,  true)
  },
  methods: {
    async loadRingGroups (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#ringGroupDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: { ...this.ringGroupSearchParams, page, itemPerPage }})
      }
      const response = await RingGroup.all({ ...this.ringGroupSearchParams, page, itemPerPage })
      this.ringGroups = response.data.data.ringGroups
      this.ringGroupPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#ringGroupDataContainer > .con-vs-loading')
    },
    async addRingGroup (e) {
      e.preventDefault()

      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationRingGroupsButton', scale: 0.45})
      if (this.ringGroupFormData.group.trim().length === 0 && this.ringGroupFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_ring_group_error_message_if_empty_ring_group_and_empty_name'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.ringGroupFormData.group.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_ring_group_error_message_if_empty_ring_group'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.ringGroupFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_ring_group_error_message_if_empty_name'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await RingGroup.store(this.ringGroupFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadRingGroups(1, this.itemPerPage)
        this.ringGroupFormData = {
          company_id: '',
          name: '',
          group: '',
          id: ''
        }
        this.ringGroupFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationRingGroupsButton > .con-vs-loading')
    },
    async edit (key) {
      this.ringGroups[key].edit = true
      const editElem = this.ringGroups[key]
      const editObj = {
        name: editElem.name,
        group: editElem.group
      }
      this.ringGroupsEdit[key] = editObj
    },
    async cancel (key) {
      this.ringGroups[key].name = this.ringGroupsEdit[key].name
      this.ringGroups[key].group = this.ringGroupsEdit[key].group
      this.ringGroups[key].edit = false
      this.ringGroups[key].ringGroupFormErrors = {}
      delete this.ringGroupsEdit[key]
    },
    async save (key, id) {
      this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationRingGroupsButton${  id}`, scale: 0.45})
      try {
        await RingGroup.update(this.ringGroups[key])
        this.ringGroups[key].edit = false
        this.ringGroups[key].ringGroupFormErrors = {}
      } catch (e) {
        this.ringGroups[key].ringGroupFormErrors = e.response.data.errors
      }
      this.$vs.loading.close(`#updateConfigurationRingGroupsButton${  id  } > .con-vs-loading`)
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await RingGroup.destroy({ id })
        this.loadRingGroups(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationRingGroupsButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
